import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import type { ReqSearchApplicants, ResSearchApplicants } from './types'

export const searchApplicantQueryKey = {
  base: ['applicants'],
  full: (params: ReqSearchApplicants) => ['applicants', params],
}

export const searchApplicantQuery = (params: ReqSearchApplicants) => {
  const { asc, keyword, pageNumber, pageSize, sort = 'id', tagCondition = 'or', tags = [] } = params

  return queryOptions({
    queryKey: searchApplicantQueryKey.full({
      asc,
      pageNumber,
      pageSize,
      keyword,
      sort,
      tagCondition,
      tags,
    }),
    queryFn: (): Promise<ResSearchApplicants> => {
      return w
        .post(
          {
            asc,
            pageNumber,
            pageSize,
            keyword,
            sort,
            tagCondition,
            tags,
          },
          API_ENDPOINTS.business.v2.applicant.search.index
        )
        .json()
    },
    placeholderData: keepPreviousData,
  })
}
